import React, { useState, useEffect } from "react";
import { makeStyles, Grid, CircularProgress } from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyle = makeStyles((theme) => ({
  setMargin: {
    marginBottom: "5%",
    textAlign: "left",
    fontSize: "1rem",
  },
  imgStyle: {
    width: "75px",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10%",
    margin: "5%",
  },
  textStyle: {
    lineHeight: "2.5",
    [theme.breakpoints.down("sm")]: {
      lineHeight: "1",
    },
    [theme.breakpoints.between("sm", "md")]: {
      marginRight: "30px",
    },
  },
  linkStyle: {
    lineHeight: 2.5,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
    },
  },
}));

const PostCard = ({ postTitle, postId }) => {
  const classes = useStyle();
  const [imgSrc, setImgSrc] = useState("");
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const getImgUrl = `https://natakallam.com/wp-json/wp/v2/media?parent=${postId}`;
    fetch(getImgUrl)
      .then((resp) => resp.json())
      .then((img) => {
        setImgSrc(img);
        setLoaded(true);
      });
  }, [postId]);
  if (loaded) {
    return (
      <Grid container spacing={5} className={classes.setMargin}>
        <Grid item>
          <img
            className={classes.imgStyle}
            src={imgSrc[0].source_url}
            alt={postTitle}
          ></img>
        </Grid>
        <Grid item>
          <Link className={classes.linkStyle} to={`/blogs/${postId}`}>
            {postTitle}
          </Link>
        </Grid>
      </Grid>
    );
  }
  return <CircularProgress />;
};

export default PostCard;
